import React, { useEffect, useState } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Paper = () => {
    const {SetNotification ,API} =useStateContext () ;
  const [user, setUser] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const { id } = useParams();
  const [att_id, setAtt_id] = useState(0) ; 

const navigate = useNavigate() ; 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get(`/Registeration/show/${id}`);
        if (response.status === 200) {
          console.log(response);
          setUser(response.data.user);
          setAtt_id(response.data.lastAttend); 
          setIsLoading(false);
        }
      } catch (error) {
        console.log('Error fetching data:', error);
      }
    };

    fetchData();
  }, [id]);


  
  const handelCancel = async()=>{
   
      navigate(-1); 
    
  }
    
  const handelDelete = async()=>{
    const confirmed = window.confirm('Are you sure you want to delete this attendind ?');
    if (confirmed) {
      await AxiosClient.post("Registeration/Declined/" + att_id ).then(()=>{
        navigate(-1); 

      }).catch((err)=> alert("somthing bad happen")); 

    }
  
}
  return (
    <>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Request Attending</h4>
        </div>
        {loading ? (
          <Loader label="Loading attendee details..." />
        ) : (
          <div className="card-body">
            <div className="card-content text-dark">
              <div className="row">
                <div className="col-6">
                  <p className="card-text">
                    <span className="text-bold">English Name:</span>{' '}
                    {user.first_name} {user.last_name}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Email:</span> {user.email}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Position:</span> {user.position}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Gender:</span> {user.gender}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Address:</span> {user.country} {user.city}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Organization:</span> {user.organization}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Nationality:</span>{user.nationality}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Phone:</span> {user.phone}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Role:</span> {user.role}
                  </p>
                  <p className="card-text">
   
                  </p>
                </div>
                <div className="col-6 text-end">
                  <img
                  src={`${API}${user.image}`}
                    className="w-25 border"
                    alt="Profile"
                  />
                </div>
              </div>
           
              <button className='btn btn-dark m-2' onClick={handelCancel}>
                cancel
              </button>
              <button className='btn btn-danger m-2' onClick={handelDelete}>
              Delete
              </button>
              
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Paper;